import {wdiCore, WdiModalAppProps} from "@/components/WdiControls";
import {HorzLayoutOpts, WdiModalForm} from "@/components/WdiControls/WdiModalForm";
import {Form, Input, message} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {ProFormInstance} from "@ant-design/pro-form";
import {FormSp} from "@/services/sales/sp";
import {ResponseStatus} from "@/utils/request";
import {Enum} from "@/enums/system";
import {VatType} from "@/services/mdm/vattype";
import {WdiInputNumber} from "@/components/WdiControls/WdiInputNumber";

const RebateSpDetailEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const {row, formSp} = props.data;
  const [vatType, setVatType] = useState<API.VatType>();

  const isInVat = () => {
    return Enum.PaymentMethod.BILL_DEDUCT == row.paymentMethodId
      || Enum.PaymentMethod.FG_POOL == row.paymentMethodId
      || Enum.PaymentMethod.FEE_POOL == row.paymentMethodId;
  }

  useEffect(() => {
    if (row) {
      formRef.current?.setFieldsValue({
        boName: row.boName,
        soldToName: wdiCore.String.Join(row.soldToCode, row.soldToName),
        shipToName: wdiCore.String.Join(row.shipToCode, row.shipToName),
        productNamesRebate: row.productNamesRebate,
        ecName: row.ecName,
        fperiod: row.fperiod,
        speriod: row.speriod,
        amountSs: row.amountSs,
        amountNotPaid: row.amountNotPaid,
        amountInVatOriginal: row.amountInVat,
        amountExVatOriginal: row.amountExVat,
      });
      VatType.get(row.vatTypeId).then(response => {
        setVatType(response.data);
      });
    }
  }, [props.data]);

  const handleAmountInVatChange = (amountInVat: any) => {
    if (isInVat()) {
      formRef.current?.setFieldsValue({
        amountExVat: wdiCore.Number.ToNumber(amountInVat / (1 + Number(vatType?.vatTypeValue)), 2),
      });
    }
  };

  return (
    <WdiModalForm
      {...HorzLayoutOpts}
      formRef={formRef}
      title={props.title}
      visible={props.visible}
      modalProps={{
        onCancel: () => {
          props.onClose?.()
        },
      }}
      onFinish={async (values) => {
        const entity: any = {
          amountInVat: values.amountInVat,
          amountExVat: values.amountExVat,
          modifiedReason: values.modifiedReason,
        };

        const response = await FormSp.Buttons.modifyAmount({
          pageTypeId: formSp.pageTypeId,
          formSpDetail: Object.assign({}, row, entity),
        });
        if (response.code !== ResponseStatus.SUCCESS) {
          message.error(response.message);
          return;
        }
        message.success('保存成功');
        if (props.onSave) {
          response.data = Object.assign({}, {...row}, response.data);
          props.onSave(response);
        }
      }}
    >
      <Form.Item name="boName" label="四级使用部门">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="soldToName" label="客户">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="shipToName" label="收货地">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="productNamesRebate" label="产品别">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="ecName" label="费用项">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="fperiod" label="预提月份">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="speriod" label="销售日期">
        <Input readOnly/>
      </Form.Item>
      <Form.Item name="amountSs" label="结案金额">
        <WdiInputNumber readOnly={true}/>
      </Form.Item>
      <Form.Item name="amountNotPaid" label="可核销金额">
        <WdiInputNumber readOnly={true}/>
      </Form.Item>
      <Form.Item name="amountInVatOriginal" label="原核销金额(含税)">
        <WdiInputNumber readOnly={true}/>
      </Form.Item>
      <Form.Item name="amountExVatOriginal" label="原核销金额(未税)">
        <WdiInputNumber readOnly={true}/>
      </Form.Item>
      <Form.Item name="amountInVat" label="最终核销金额(含税)"
                 rules={[{required: true, message: '最终核销金额(含税)不能为空'}]}>
        <WdiInputNumber onChange={(value) => {
          handleAmountInVatChange(value);
        }}/>
      </Form.Item>
      <Form.Item name="amountExVat" label="最终核销金额(未税)"
                 rules={[{required: true, message: '最终核销金额(未税)不能为空'}]}>
        <WdiInputNumber readOnly={isInVat()}/>
      </Form.Item>
      <Form.Item name="modifiedReason" label="修改原因"
                 rules={[{required: true, message: '修改原因不能为空'}]}>
        <Input.TextArea rows={2}/>
      </Form.Item>
    </WdiModalForm>
  )
}
export default RebateSpDetailEditApp;
